interface IOngoingTripsExtra {
    assigned: number;
    notAssigned: number;
}

interface IVehiclesExtra {
    reporting: number;
    notReporting: number;
}
interface IDelayedTripsExtra {
    average: number;
}

interface IEfficiencyExtra {
    travelWithoutDelay: number;
}

export interface ITripsStatsSchema {
    extra: IOngoingTripsExtra | IVehiclesExtra | IDelayedTripsExtra | IEfficiencyExtra;
    value: string;
    icon: string;
    title: string;
}
